import { createContext } from 'react';

import type { StandardCardSharedProps } from './types';

// Create a context for shared props
export const StandardCardSharedPropsContext =
  createContext<StandardCardSharedProps>({
    layout: 'horizontal',
    disabled: false,
  });
